import React from "react";
import styles from "./UiLibraryComponent.module.css";
import GoBackIcon from "Utils/Assets/SVGs/GoBackIcon";
import { useScrollToTop } from "../../../Logic/Functions/Hooks/useScrollToTop";

const ScrollToTopButton: React.FC = () => {
  const { visible, scrollToTop } = useScrollToTop();

  return (
    <button
      type="button"
      onClick={scrollToTop}
      className={styles.scrollTopButton}
      data-testid="scroll-to-top"
      aria-label="Scroll back to top"
      hidden={!visible}
    >
      <GoBackIcon className={styles.icon} aria-hidden="true" />
    </button>
  );
};

export default ScrollToTopButton;
